import axios from 'axios';
import storageService from '../services/storageService';

const token = storageService.getItem('accessToken');

const clientApi = axios.create({
  baseURL: `${window._env_.REACT_APP_API}/api/v2`,
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  },
});

clientApi.interceptors.request.use(
  (config) => {
    const token = storageService.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      delete config.headers.Authorization;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

clientApi.interceptors.response.use(
  (response) => response,
  async (error) => Promise.reject(error),
);

const request = async (method, url, options = {}) => {
  const response = await clientApi({
    method,
    url,
    params: options.params,
    data: options.data,
  });

  return response.data;
};

export const get = (url, params) => {
  return request('GET', url, { params });
};

export const post = (url, data, params) => {
  return request('POST', url, {
    data,
    ...(params ? { params } : {}),
  });
};

export const patch = (url, data, params) => {
  return request('PATCH', url, {
    data,
    ...(params ? { params } : {}),
  });
};

export const deletee = (url, params = {}, data = {}) => {
  return request('DELETE', url, { params, data });
};

export default {
  get,
  post,
  patch,
  delete: deletee,
};


export const regenerateReport = async (id) => {
  const result = await post(`/Reports/regenerate`, undefined, { requestId : id});
  return result;
};
